import PropTypes from 'prop-types';
import React from 'react';
import { candidatesPartiesRankingWidget } from '@sky-it-elections/widgets';
import { PartiesRankingBlock, IPartiesRanking } from '@sky-it-elections/design-system';

import { IWrapperModel } from '../../typings/common-types';
import { getModelFromUseService, isEmptyObject } from '../../utils/props-validator';
import { useService } from '../hooks/useService';

export interface ICandidatesPartiesRankingWrapper extends IWrapperModel<IPartiesRanking> {}

const PartiesRankingBlockWrapper: React.FC<ICandidatesPartiesRankingWrapper> = ({
  query,
  initialModel,
  live = false,
}) => {
  const { model } = useService({
    live,
    initialValue: initialModel,
    query,
    widget: candidatesPartiesRankingWidget,
  });

  const args: IPartiesRanking = {
    ...getModelFromUseService(model),
  };

  return !isEmptyObject(args) ? <PartiesRankingBlock {...args} /> : null;
};

PartiesRankingBlockWrapper.propTypes = {
  initialModel: PropTypes.any.isRequired,
  live: PropTypes.bool,
  query: PropTypes.object.isRequired,
};

PartiesRankingBlockWrapper.defaultProps = {
  live: true, // triggers SUBSCRIPTION
};

export default PartiesRankingBlockWrapper;
